import { Chip, ChipProps } from '@mui/material';

type StatusType = 'success' | 'warning' | 'error' | 'info' | 'default';

interface StatusChipProps {
  label: string;
  status: StatusType;
  size?: ChipProps['size'];
}

const statusColors: Record<StatusType, ChipProps['color']> = {
  success: 'success',
  warning: 'warning',
  error: 'error',
  info: 'info',
  default: 'default',
};

export function StatusChip({ label, status, size = 'small' }: StatusChipProps) {
  return (
    <Chip
      label={label}
      color={statusColors[status]}
      size={size}
      variant="filled"
    />
  );
}

// Helper para status de venda
export function VendaStatusChip({ status }: { status: string }) {
  const statusMap: Record<string, { label: string; type: StatusType }> = {
    PENDENTE: { label: 'Pendente', type: 'warning' },
    FINALIZADA: { label: 'Finalizada', type: 'success' },
    CANCELADA: { label: 'Cancelada', type: 'error' },
  };

  const config = statusMap[status] || { label: status, type: 'default' };
  return <StatusChip label={config.label} status={config.type} />;
}

// Helper para status ativo/inativo
export function AtivoStatusChip({ ativo }: { ativo: boolean }) {
  return (
    <StatusChip
      label={ativo ? 'Ativo' : 'Inativo'}
      status={ativo ? 'success' : 'error'}
    />
  );
}

export default StatusChip;
